import Image from 'next/image'
import firtsTimeIcon from '@/assets/svg/firts-time.svg'
import GoogleIcon from '@wiggui/ds/GoogleIcon'
import { composeClasses } from '@wiggot/utils/src/strings'

interface IProps {
  onClickSearch: () => void
  hiddeMap: boolean
}
export const FirtsSearch = ({ hiddeMap, onClickSearch }: IProps) => {
  return (
    <div
      className={composeClasses(
        'relative px-6 py-3 overflow-y-auto w-[692px] bg-surface-gray-10',
        hiddeMap ? 'w-full' : 'w-[692px]'
      )}
    >
      <div className="absolute right-0 md:right-[96px] top-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          fill="none"
        >
          <mask
            id="a"
            style={{ maskType: 'luminance' }}
            width="80"
            height="80"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M80 0H0v80h80V0z" />
          </mask>
          <g mask="url(#a)">
            <path
              fill="#FFC107"
              fillRule="evenodd"
              d="M.001 80A20.582 20.582 0 010 79.8c0-10.156 7.495-18.561 17.255-19.987C7.508 58.475 0 50.114 0 40c0-11.046 8.954-20 20-20h.2C9.11 20 .108 11.064.001 0h79.998c-.107 11.064-9.11 20-20.199 20h.2c11.046 0 20 8.954 20 20 0 10.114-7.508 18.475-17.255 19.813C72.505 61.24 80 69.644 80 79.8v.2H0z"
              clipRule="evenodd"
            />
          </g>
        </svg>
      </div>
      <div className="absolute left-[57px] bottom-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="120"
          height="81"
          fill="none"
          viewBox="0 0 120 81"
        >
          <g>
            <mask
              id="mask0_19735_43222"
              style={{ maskType: 'luminance' }}
              width="120"
              height="120"
              x="0"
              y="0"
              maskUnits="userSpaceOnUse"
            >
              <g>
                <path fill="#fff" d="M120 0H0v120h120V0z" />
              </g>
            </mask>
            <g mask="url(#mask0_19735_43222)">
              <g>
                <path
                  fill="#BA68C8"
                  fillRule="evenodd"
                  d="M64.286 0h-8.572v37.952L41.497 2.763 33.55 5.974l14.585 36.1-27.53-27.53-6.062 6.06 26.388 26.388L6.734 32.05l-3.431 7.854 36.183 15.81H0v8.57h39.486L3.303 80.096l3.431 7.854 34.197-14.94-26.388 26.387 6.061 6.061 27.531-27.531-14.585 36.1 7.947 3.21 14.217-35.188V120h8.572V82.048l14.217 35.188 7.947-3.21-14.585-36.1 27.531 27.531 6.061-6.061-26.388-26.387 34.197 14.94 3.431-7.854-36.183-15.81H120v-8.57H80.513l36.184-15.81-3.431-7.854-34.197 14.94 26.388-26.387-6.061-6.06-27.531 27.53 14.585-36.1-7.947-3.21-14.217 35.188V0z"
                  clipRule="evenodd"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div className="w-full h-full flex flex-col gap-6 justify-center items-center">
        <Image src={firtsTimeIcon} alt="Primera búsqueda" />
        <p className="text-base font-semibold">
          Comienza realizando una búsqueda
        </p>
        <article className="flex flex-col gap-1 items-center text-secondary text-sm font-medium">
          <p className="flex items-center gap-1">
            Usa la{' '}
            <button
              onClick={onClickSearch}
              type="button"
              className="flex gap-1 items-center text-blue text-sm font-medium px-2 py-[2px] border border-blue rounded-full shadow-[0px_3px_6px_0px_rgba(34,34,34,0.16)]"
            >
              barra de búsqueda
              <GoogleIcon
                className="text-base leading-4 font-medium"
                name="search"
              />
            </button>{' '}
            superior
          </p>
          <p>para explorar propiedades</p>
        </article>
      </div>
    </div>
  )
}
